import {Grid,Typography, Box} from "@mui/material"
import React, { useEffect,useState} from "react"
import AlertMessage from "src/components/alert-message"
import DatalakeService from "src/services/datalake-service"
import PropTypes from 'prop-types'
// import ParameterTable from "src/components/table/parameter-table"
import { DataGrid } from "@mui/x-data-grid"
import { TokenService } from "src/services/token-service"
import { renderCellCpfCnpj } from "src/utils/table-render-functions"


const GrupoEconomico = ({empresa,loading, onSelectEmpresa }) => {
    const datalakeservice = new DatalakeService()
    const tokenService = new TokenService()
    const [userAdmin, setUserAdmin] = useState(false)
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })
    const [data, setData] = useState([])
    const [alertMessageState, setAlertMessageState] = React.useState({
        open: false,
        message: "",
        type: "info"
    })

    useEffect(() => {

        if (empresa) {
            const userIsAdmin = tokenService.verifyUserIsAdmin()
            setUserAdmin(userIsAdmin)
            loadData()
        } 
    }, [empresa])

    const handleRowClick = (data) => {
        if (onSelectEmpresa) {
            onSelectEmpresa(data) // Chama a função passada pelo pai
        }
    }

    const openAlert = (message, type) => {
        setAlertMessageState({
            ...alertMessageState,
            open: true,
            message: message,
            type: type
        })
    }

    const closeAlert = () => {
        setAlertMessageState({ ...alertMessageState, open: false })
    }

    const loadData = () => {
        const raizCNPJ = empresa?.RaizCNPJ || ""
    
        // Verifica se 'empresaPrimeiraParte' está vazio
        if (!raizCNPJ) {
            openAlert("CNPJ inválido ou não selecionado. Por favor, verifique.", "warning")
            loading(false)
            return // Sai da função caso a empresa seja inválida
        }
    
        loading(true)
        datalakeservice.loadgrupoecon(raizCNPJ)
            .then((response) => {
                loading(false)
    
                const { body } = response
    
                if (body && body.data) {
                    const { data, count, next, previous } = body
                    const list = data.map((obj, index) => ({ ...obj, id: index }))
    
                    setPagination({ count: count, next: next, previous: previous })
                    setData(list)
                } else {
                    openAlert("Dados não encontrados na resposta.", "warning")
                    setPagination({ count: 0, next: null, previous: null })
                    setData([])
                }
            })
            .catch((error) => {
                loading(false)
                console.error("Erro ao buscar dados:", error)
                setPagination({ count: 0, next: null, previous: null })
                setData([])
            })
    }

    const renderTextColumn = (params) =>
        <Box sx={{ whiteSpace: 'pre-line', height: 'auto' }}>
            <Typography variant="p">{params.value}</Typography>
        </Box>
    

    const columns = [
        {
            field: 'id',
            headerName: '#',
            flex: true,
            minWidth: 50, 
            maxWidth: 70, 
        },
        {
            field: 'RazaoSocial',
            headerName: 'Razão Social',
            flex: 1,
            minWidth: 270,
            maxWidth: 350,
            editable: false,
            renderCell: renderTextColumn
        },
        {
            field: 'NomeFantasia',
            headerName: 'Nome Fantasia',
            flex: 1,
            minWidth: 130,
            maxWidth: 300,
            editable: false,
            renderCell: renderTextColumn
        },
        {
            field: 'CPFCNPJ',
            headerName: 'CNPJ',
            flex: 1,
            minWidth: 170,
            maxWidth: 350,
            editable: false,
            renderCell: renderCellCpfCnpj
        },
        {
            field: 'TipoCadastro',
            headerName: 'Tipo Cadastro',
            flex: 1,
            minWidth: 110,
            maxWidth: 300,
            editable: false
        },
        {
            field: 'Setor',
            headerName: 'Setor',
            flex: 1,
            minWidth: 150,
            maxWidth: 250,
            editable:  false,
            renderCell: renderTextColumn
        },
        {
            field: 'SubSetor',
            headerName: 'SubSetor',
            flex: 1,
            minWidth: 150,
            maxWidth: 150,
            editable:  false,
            renderCell: renderTextColumn
        },
        {
            field: 'Rating_C2P',
            headerName: 'Score C2P',
            flex: 1,
            minWidth: 80,
            maxWidth: 80,
            editable:  false,
        }, ...(userAdmin ? [{
            field: 'DataValidade_C2P',
            headerName: 'Validade C2P',
            flex: 1,
            minWidth: 120,
            maxWidth: 120,
            editable: false,
        }] : []),
        {
            field: 'Rating_Moodys',
            headerName: 'Moody\'s',
            flex: 1,
            minWidth: 90,
            maxWidth: 90,
            editable:  false,
        },
        {
            field: 'Rating_Fitch',
            headerName: 'Fitch',
            flex: 1,
            minWidth: 80,
            maxWidth: 80,
            editable:  false,
        },
        {
            field: 'Rating_SP',
            headerName: 'S&P',
            flex: 1,
            minWidth: 80,
            maxWidth: 80,
            editable:  false,
        },
    ]
    
    return (
        <Grid>
            <AlertMessage open={alertMessageState.open} message={alertMessageState.message} type={alertMessageState.type} close={closeAlert} />

            {empresa?.RaizCNPJ && (
                <>
                    <Box 
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: 2,
                            p: 2,
                            backgroundColor: "#ffffff",
                            borderRadius: 2,
                            boxShadow: 2,
                            textAlign: "center"
                        }}>
                        <Typography variant="subtitle1"><strong>Grupo Econômico:</strong> {empresa.GrupoEconomico_Nome || "Não informado"}</Typography>
                        <Typography variant="subtitle1"><strong>Raiz CNPJ:</strong> {String(empresa.GrupoEconomico_RaizCNPJ || "Não informado")}</Typography>
                    </Box>
                    <br />

                    <Grid item xs={12}>
                        <DataGrid
                            columns={columns}
                            rows={data}
                            pagination={pagination}
                            pageSize={25}
                            disableDeleteColumn={true}
                            autoHeight
                            sx={{
                                backgroundColor: "#FFFFFF" 
                            }}
                            onRowClick={handleRowClick}
                        />
                    </Grid>
                </>
            )}
        </Grid>

    )
}

GrupoEconomico.propTypes = {
    loading: PropTypes.func,
    empresa: PropTypes.object.isRequired,
    onSelectEmpresa: PropTypes.func.isRequired,
}

export default GrupoEconomico